module.exports = __webpack_public_path__ + "img/finances@500w.47fc4ed5.webp";